import { create } from "zustand";
import { persist } from "zustand/middleware";

type AuthState = {
  token: string | null;
  role: string | null;
  setSession: (token: string, role: string) => void;
  logout: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      role: null,
      setSession: (token, role) => set({ token, role }),
      logout: () => set({ token: null, role: null }),
    }),
    { name: "cw-admin-auth" }
  )
);
